export enum LanguageCode {
  EN = 'en',
  ZU = 'zu',
  XH = 'xh',
  AF = 'af',
  TN = 'tn',
  TS = 'ts',
}

export type TriageLevel = 'emergency' | 'urgent' | 'monitor' | 'selfcare' | null;

export interface Message {
  id: string;
  role: 'user' | 'model';
  content: string;
  timestamp: number;
  language: LanguageCode;
  triageLevel?: TriageLevel;
}

export interface Translation {
  welcomeTitle: string;
  welcomeSubtitle: string;
  selectLanguage: string;
  inputPlaceholder: string;
  sendButton: string;
  disclaimerTitle: string;
  disclaimerText: string;
  disclaimerFooter: string;
  loading: string;
  error: string;
  newChat: string;
  saveChat: string;
  features: {
    title: string;
    items: string[];
  };
  triage: {
    emergency: string;
    urgent: string;
    monitor: string;
    selfcare: string;
    emergencyAction: string;
    urgentAction: string;
    monitorAction: string;
    selfcareAction: string;
  };
}

export interface ChatState {
  messages: Message[];
  isLoading: boolean;
  error: string | null;
  selectedLanguage: LanguageCode;
}

export type ChatAction =
  | { type: 'ADD_MESSAGE'; payload: Message }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_LANGUAGE'; payload: LanguageCode }
  | { type: 'CLEAR_CHAT' }
  | { type: 'RESET_SESSION' };
